import { Context } from '@/models/order-history/status/context/context'
import { getIsBeforeCancellable } from '@spa/components/organisms/mypage/order/model/order-cancellation-state'
import {
  CannotReorderDuringOrderRegistrationError,
  OrderHistoryNotFetchedError,
} from '@spa/components/pages/mypage/order/reorder/model/modal-state'
import { SpecificationList, success, ValidationResult } from '@spa/components/pages/mypage/order/reorder/model/specification/profile/index'

interface OrderStatusSpecification {
  validate(input: Context | undefined | null): ValidationResult
}

export class OrderStatusSpecificationList
  extends SpecificationList<Context, OrderStatusSpecification>
  implements OrderStatusSpecification {}

export class ReorderAfterRegistrationSpecification implements OrderStatusSpecification {
  constructor(private readonly postProcess: () => void) {}

  validate(input: Context | undefined | null): ValidationResult {
    const ifNonNull = requireNonNull(input, this.postProcess)

    return ifNonNull((nonNullInput) => {
      if (getIsBeforeCancellable(nonNullInput)) {
        return {
          modalState: new CannotReorderDuringOrderRegistrationError(),
          postProcess: this.postProcess,
          isInvalid: true,
        }
      }

      return success()
    })
  }
}

const requireNonNull =
  (input: Context | undefined | null, postProcess: () => void) =>
    (onExist: (_input: Context) => ValidationResult) => {
      if (!input) {
        return  {
          modalState: new OrderHistoryNotFetchedError(),
          postProcess,
          isInvalid: true,
        }
      }

      return onExist(input)
    }
